// extracted by mini-css-extract-plugin
module.exports = {"dialogClose":"m_b","buttonBox":"m_c","dialogMessage":"m_e","scrollable":"m_f"};